import { render, staticRenderFns } from "./DocumentDataTableSelectable.vue?vue&type=template&id=93f9b730"
import script from "./DocumentDataTableSelectable.vue?vue&type=script&lang=js"
export * from "./DocumentDataTableSelectable.vue?vue&type=script&lang=js"
import style0 from "./DocumentDataTableSelectable.vue?vue&type=style&index=0&id=93f9b730&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports